export default __webpack_public_path__ + "a2191e0.png";